// extracted by mini-css-extract-plugin
module.exports = {"container":"InvoicePanel_container__qrowc","title":"InvoicePanel_title__mwGu_"};